import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars, FaDiscord, FaTimes } from "react-icons/fa";

const discordUrl = "https://discord.com/invite/BusuZp2G8w";
const statusUrl = "https://status.afterpartylabs.xyz";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);

  const navLinkClass = ({ isActive }) =>
    [
      "rounded-lg px-3 py-2 text-sm sm:text-base font-medium tracking-wide transition-colors duration-240 focus-visible:outline-none focus-visible:shadow-none focus-ring-neo",
      isActive
        ? "text-apb-accent-cyan border-l-2 border-apb-accent-cyan md:border-l-0 md:border-b-2 md:border-apb-accent-cyan"
        : "text-white/85 hover:text-white hover:bg-white/10 md:hover:bg-transparent",
    ].join(" ");

  return (
    <nav className="sticky top-0 z-50 border-b border-apb-border-soft bg-apb-panel apb-surface-glass apb-glow-cyan text-white shadow-lg">
      <div className="flex w-full items-center justify-between px-6 py-3 sm:px-8">
        <Link to="/" onClick={closeMenu} className="shrink-0" aria-label="Afterparty Bot Labs home">
          <img src="/logo.png" alt="Afterparty BotLabs" className="h-10 w-auto" />
        </Link>

        <button
          type="button"
          className="rounded-lg p-2 text-xl text-white/90 hover:text-white hover:bg-white/10 focus:outline-none focus-ring-neo md:hidden"
          aria-expanded={isOpen}
          aria-controls="primary-navigation"
          aria-label={isOpen ? "Close navigation" : "Open navigation"}
          onClick={() => setIsOpen((open) => !open)}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div
          id="primary-navigation"
          className={`${
            isOpen ? "flex" : "hidden"
          } absolute left-0 right-0 top-full flex-col gap-2 border-b border-apb-border-soft bg-apb-bg-deep/90 px-4 py-4 shadow-lg backdrop-blur md:static md:flex md:flex-row md:items-center md:gap-6 md:border-0 md:bg-transparent md:p-0 md:shadow-none`}
        >
          <NavLink to="/about" onClick={closeMenu} className={navLinkClass}>
            About Us
          </NavLink>
          <a
            href={statusUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMenu}
            className="rounded-lg px-3 py-2 text-sm sm:text-base font-medium text-white/85 transition-colors duration-240 hover:text-white hover:bg-white/10 md:hover:bg-transparent md:p-0 focus-visible:outline-none focus-visible:shadow-none focus-ring-neo"
          >
            Status
          </a>
          <NavLink to="/support-us" onClick={closeMenu} className={navLinkClass}>
            Support Us
          </NavLink>
          <a
            href={discordUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMenu}
            className="apb-btn apb-glow-cyan flex items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm sm:text-base font-semibold tracking-wide transition-all duration-240 hover:scale-[1.02]"
          >
            <FaDiscord className="text-xl" />
            Join Discord
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

